export default "__VITE_ASSET__Cx5VjvId__"